import React, { createContext, useState, useEffect } from 'react';

export const ThemeContext = createContext();

// Read initial theme synchronously and apply data-theme before first paint
const getInitialTheme = () => {
  if (typeof window === 'undefined') {
    return 'dark';
  }

  // Force dark mode regardless of localStorage
  const initialTheme = 'dark';

  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('data-theme', initialTheme);
    document.body.setAttribute('data-theme', initialTheme);
  }

  return initialTheme;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    // Save theme to localStorage
    window.localStorage.setItem('theme', theme);
    
    // Apply theme to document
    document.documentElement.setAttribute('data-theme', theme);
    document.body.setAttribute('data-theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    // Disable switching to light mode
    setTheme('dark');
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
